import { Link } from 'react-router-dom';

/**
 * Shared chrome for the three legal pages — Privacy, Terms, Data Deletion.
 * Re-uses the landing-page nav + footer styles for visual continuity so
 * a Meta App Review screencast that loads /privacy or /terms lands on a
 * page that obviously belongs to the same product as the landing page.
 *
 * The pages themselves are public — no auth required, by design. Meta
 * crawls them during App Review, and so do GDPR auditors later.
 */
export default function LegalLayout({ title, lastUpdated, children }) {
  return (
    <div className="landing-shell">
      <header className="landing-nav">
        <div className="landing-nav-inner">
          <Link to="/" className="landing-brand" style={{ textDecoration: 'none' }}>
            <img src="/icons/markaii-m.png?v=2" alt="" className="brand-icon" />
            <span>Markaii</span>
          </Link>
          <nav className="landing-nav-links">
            <Link to="/">Home</Link>
            <Link to="/login" className="btn btn-primary btn-compact">Sign in</Link>
          </nav>
        </div>
      </header>

      <main className="landing-container legal-page">
        <h1 className="legal-title">{title}</h1>
        <p className="legal-meta">Last updated: {lastUpdated}</p>
        <div className="legal-body">{children}</div>
      </main>

      <footer className="landing-footer">
        <div className="landing-container landing-footer-inner">
          <span className="landing-brand-mini">Markaii</span>
          <span className="landing-footer-meta">
            <Link to="/privacy">Privacy</Link>
            {' · '}
            <Link to="/terms">Terms</Link>
            {' · '}
            <Link to="/data-deletion">Data deletion</Link>
            {' · '}
            © {new Date().getFullYear()} markaii.com
          </span>
        </div>
      </footer>
    </div>
  );
}
